export default __webpack_public_path__ + "static/media/loader.76ef0cac.gif";